import React, { useRef } from "react";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";
import {
  Section,
  StickyContainer,
  ContentWrapper,
  ContentContainer,
  GradientText,
  VideoContainer,
  Video,
  ScrollArea,
  FeatureCard,
  FeatureIcon,
  FeatureContent,
  FeatureTitle,
  FeatureDescription,
  FeatureImageContainer,
  FeatureImage,
} from "../styles/sections/SubFeaturesSectionStyles";

function SubFeaturesSection() {
  const scrollRef = useRef(null);
  const scroll2Ref = useRef(null);
  const scroll3Ref = useRef(null);
  const scroll4Ref = useRef(null);
  const scroll5Ref = useRef(null);

  const { scrollYProgress: scroll2Progress } = useScroll({
    target: scroll2Ref,
    offset: ["start end", "end end"]
  });

  const { scrollYProgress: scroll3Progress } = useScroll({
    target: scroll3Ref,
    offset: ["start end", "end end"]
  });

  const { scrollYProgress: scroll4Progress } = useScroll({
    target: scroll4Ref,
    offset: ["start end", "end end"]
  });

  const { scrollYProgress: scroll5Progress } = useScroll({
    target: scroll5Ref,
    offset: ["start end", "end end"]
  });

  const secondContainerY = useSpring(
    useTransform(scroll2Progress, [0, 1], [window.innerWidth <= 768 ? 0 : 600, 0]),
    {
      stiffness: 100,
      damping: 30,
      mass: 1
    }
  );

  const thirdContainerY = useSpring(
    useTransform(scroll3Progress, [0, 1], [window.innerWidth <= 768 ? 0 : 600, 0]),
    {
      stiffness: 100,
      damping: 30,
      mass: 1
    }
  );

  const fourthContainerY = useSpring(
    useTransform(scroll4Progress, [0, 1], [window.innerWidth <= 768 ? 0 : 600, 0]),
    {
      stiffness: 100,
      damping: 30,
      mass: 1
    }
  );

  // 배경색 변경을 위한 상태
  const [bgColors, setBgColors] = React.useState({
    first: window.innerWidth > 768 ? "rgb(247, 96, 0)" : "rgb(0, 0, 0)",
    second: "rgb(0, 0, 0)",
    third: "rgb(0, 0, 0)",
    fourth: "rgb(0, 0, 0)"
  });

  // 스크롤에 따른 배경색 변경
  React.useEffect(() => {
    if (window.innerWidth <= 768) return;

    const unsubscribe = scroll4Progress.onChange((value) => {
      if (value === 1) {
        setBgColors({
          first: "rgb(0, 0, 0)",
          second: "rgb(0, 0, 0)",
          third: "rgb(0, 0, 0)",
          fourth: "rgb(247, 96, 0)"
        });
      } else if (value === 0) {
        setBgColors({
          first: "rgb(0, 0, 0)",
          second: "rgb(0, 0, 0)",
          third: "rgb(247, 96, 0)",
          fourth: "rgb(0, 0, 0)"
        });
      }
    });

    return () => unsubscribe();
  }, [scroll4Progress]);

  React.useEffect(() => {
    if (window.innerWidth <= 768) return;

    const unsubscribe = scroll3Progress.onChange((value) => {
      if (value === 1 && bgColors.fourth !== "rgb(247, 96, 0)") {
        setBgColors({
          first: "rgb(0, 0, 0)",
          second: "rgb(0, 0, 0)",
          third: "rgb(247, 96, 0)",
          fourth: "rgb(0, 0, 0)"
        });
      } else if (value === 0 && bgColors.fourth !== "rgb(247, 96, 0)") {
        setBgColors({
          first: "rgb(0, 0, 0)",
          second: "rgb(247, 96, 0)",
          third: "rgb(0, 0, 0)",
          fourth: "rgb(0, 0, 0)"
        });
      }
    });

    return () => unsubscribe();
  }, [scroll3Progress, bgColors.fourth]);

  React.useEffect(() => {
    if (window.innerWidth <= 768) return;

    const unsubscribe = scroll2Progress.onChange((value) => {
      if (value === 1 && bgColors.third !== "rgb(247, 96, 0)" && bgColors.fourth !== "rgb(247, 96, 0)") {
        setBgColors({
          first: "rgb(0, 0, 0)",
          second: "rgb(247, 96, 0)",
          third: "rgb(0, 0, 0)",
          fourth: "rgb(0, 0, 0)"
        });
      } else if (value === 0 && bgColors.third !== "rgb(247, 96, 0)" && bgColors.fourth !== "rgb(247, 96, 0)") {
        setBgColors({
          first: "rgb(247, 96, 0)",
          second: "rgb(0, 0, 0)",
          third: "rgb(0, 0, 0)",
          fourth: "rgb(0, 0, 0)"
        });
      }
    });

    return () => unsubscribe();
  }, [scroll2Progress, bgColors.third, bgColors.fourth]);

  // Y 값 변화 감지
  React.useEffect(() => {
    if (window.innerWidth <= 768) return;

    const unsubscribe = thirdContainerY.onChange((value) => {
      if (value === 0 && bgColors.fourth !== "rgb(247, 96, 0)") {
        setBgColors({
          first: "rgb(0, 0, 0)",
          second: "rgb(0, 0, 0)",
          third: "rgb(247, 96, 0)",
          fourth: "rgb(0, 0, 0)"
        });
      }
    });

    return () => unsubscribe();
  }, [thirdContainerY, bgColors.fourth]);

  React.useEffect(() => {
    if (window.innerWidth <= 768) return;

    const unsubscribe = fourthContainerY.onChange((value) => {
      if (value === 0) {
        setBgColors({
          first: "rgb(0, 0, 0)",
          second: "rgb(0, 0, 0)",
          third: "rgb(0, 0, 0)",
          fourth: "rgb(247, 96, 0)"
        });
      }
    });

    return () => unsubscribe();
  }, [fourthContainerY]);

  React.useEffect(() => {
    if (window.innerWidth <= 768) return;

    const unsubscribe = secondContainerY.onChange((value) => {
      if (value === 0 && bgColors.third !== "rgb(247, 96, 0)" && bgColors.fourth !== "rgb(247, 96, 0)") {
        setBgColors({
          first: "rgb(0, 0, 0)",
          second: "rgb(247, 96, 0)",
          third: "rgb(0, 0, 0)",
          fourth: "rgb(0, 0, 0)"
        });
      }
    });

    return () => unsubscribe();
  }, [secondContainerY, bgColors.third, bgColors.fourth]);

  return (
    <Section id="subfeature" ref={scrollRef}>
      <StickyContainer data-framer-name="Sticky" className="hidden-1lkzo5d">
        <ContentWrapper>
          <ContentContainer bgColor={bgColors.first}>
            <FeatureCard>
              <FeatureIcon>
                <img 
                  src="https://framerusercontent.com/images/GwTaetpSQ00A51bimfpTtrgWuYY.png" 
                  alt="Episode Mode Icon"
                  width="54"
                  height="44"
                />
              </FeatureIcon>
              <FeatureContent>
                <FeatureTitle>EPISODE MODE</FeatureTitle>
                <FeatureDescription>
                  Experience mythical stories through the Episode Mode while enjoying the game.
                </FeatureDescription>
                <FeatureImageContainer>
                  <FeatureImage
                    src="https://framerusercontent.com/images/4n4kjsaOEBTwXAkp9pBxXlpqlgo.jpg"
                    width="801"
                    height="801"
                  />
                </FeatureImageContainer>
              </FeatureContent>
            </FeatureCard>
          </ContentContainer>

          <ContentContainer 
            as={motion.div}
            style={{
              y: secondContainerY,
              perspective: 1200,
            }}
            bgColor={bgColors.second}
          >
            <FeatureCard>
              <FeatureIcon>
                <img 
                  src="https://framerusercontent.com/images/ZVI2MoJmVZkK1UxFV33q6aR4pAs.png" 
                  alt="Clan War Mode Icon"
                  width="37"
                  height="34"
                />
              </FeatureIcon>
              <FeatureContent>
                <FeatureTitle>CLAN WAR MODE</FeatureTitle>
                <FeatureDescription>
                  Create a Clan with different players and conquer other Clans in epic battles.
                </FeatureDescription>
                <FeatureImageContainer>
                  <FeatureImage
                    src="https://framerusercontent.com/images/5hTm1NmD5j7QustmMVmdnrkg8.png"
                    width="784"
                    height="783"
                  />
                </FeatureImageContainer>
              </FeatureContent>
            </FeatureCard>
          </ContentContainer>

          <ContentContainer 
            as={motion.div}
            style={{
              y: thirdContainerY,
              perspective: 1200,
            }}
            bgColor={bgColors.third}
          >
            <FeatureCard>
              <FeatureIcon>
                <img 
                  src="https://framerusercontent.com/images/7RG6C3QEpbSBO0H1rNeDB6cs0.png" 
                  alt="Temple Upgrade Icon"
                  width="46"
                  height="36"
                />
              </FeatureIcon>
              <FeatureContent>
                <FeatureTitle>TEMPLE UPGRADE</FeatureTitle>
                <FeatureDescription>
                  Upgrade your own temple and witness its growth and transformation.
                </FeatureDescription>
                <FeatureImageContainer>
                  <FeatureImage
                    src="https://framerusercontent.com/images/kCfe6u4gnQICvxEcLeMgGyGV0g.jpg"
                    width="801"
                    height="801"
                  />
                </FeatureImageContainer>
              </FeatureContent>
            </FeatureCard>
          </ContentContainer>

          <ContentContainer 
            as={motion.div}
            style={{
              y: fourthContainerY,
              perspective: 1200,
            }}
            bgColor={bgColors.fourth}
          >
            <FeatureCard>
              <FeatureIcon>
                <img 
                  src="https://framerusercontent.com/images/QMfQ7fCE5bKYemDdqNCtr0H8pM.png" 
                  alt="Reward System Icon"
                  width="54"
                  height="47"
                />
              </FeatureIcon>
              <FeatureContent>
                <FeatureTitle>REWARD SYSTEM</FeatureTitle>
                <FeatureDescription>
                  Feel a sense of accomplishment with the Reward System.
                </FeatureDescription>
                <FeatureImageContainer>
                  <FeatureImage
                    src="https://framerusercontent.com/images/HsmX7l5mBBLcolSB3Hwt2dkzzT8.png"
                    width="1024"
                    height="1024"
                  />
                </FeatureImageContainer>
              </FeatureContent>
            </FeatureCard>
          </ContentContainer>
        </ContentWrapper>
      </StickyContainer>

      <ScrollArea ref={scroll2Ref} data-framer-name="Scroll-2" id="scroll-2" />
      <ScrollArea ref={scroll3Ref} data-framer-name="Scroll-3" id="scroll-3" />
      <ScrollArea ref={scroll4Ref} data-framer-name="Scroll-4" id="scroll-4" />
      <ScrollArea ref={scroll5Ref} data-framer-name="Scroll-5" id="scroll-5" />
    </Section>
  );
}

export default SubFeaturesSection;
